import { defineFetch } from 'resift';

const makeGetUsers = defineFetch({
  displayName: 'Get admin users',
  make: (key: string) => ({ // this key is used to allow multiple instances of the this fetch
    request: (query: any) => ({ http }) =>
      http({
        method: 'GET',
        route: `/search/users`,
        query
      }),
  }),
});

export default makeGetUsers;
